import { MonthlyOrdersStore } from '../stores/monthlyOrders';
import { cleanBillingSystemStore, getBillingCompaniesSelect } from './billingSystem';
import { setUiStatusesListArray, setUiTotal } from './ui';
import { apiManager } from '../REST';
import {
    IBodyListResponse,
    IMonthlyOrdersListAPI,
    IMonthlyOrdersListItem,
    IParamsList,
    monthlyOrderStatuses,
} from '../interfaces';
import { mapApi2UiField } from '../instruments';

export function cleanMonthlyOrdersStore(): void {
    const StoreInstance = MonthlyOrdersStore.getInstance();
    StoreInstance.cleanStore();
}

export function setMonthlyOrdersList(apiData: IMonthlyOrdersListAPI): void {
    const storeData: IMonthlyOrdersListItem[] = apiData.monthly_orders?.map((order) => {
        return {
            ...mapApi2UiField(order || {}),
        };
    }) as IMonthlyOrdersListItem[];

    const StoreInstance = MonthlyOrdersStore.getInstance();
    StoreInstance.setList(storeData);
}

export async function getMonthlyOrdersList(params: IParamsList): Promise<number> {
    const { resp } = await apiManager.getApi('GET_MONTHLY_ORDERS_LIST', { searchParamsList: params });
    const { meta } = resp as IBodyListResponse;
    meta && setUiTotal(meta.records_count);
    resp && setMonthlyOrdersList(resp as IMonthlyOrdersListAPI);
    return Number(meta?.records_count);
}

export function getMonthlyOrdersListRelationSelect(): void {
    getBillingCompaniesSelect();
    setUiStatusesListArray(Object.values(monthlyOrderStatuses));
}

export function cleanMonthlyRelationSelectAndStore(): void {
    cleanMonthlyOrdersStore();
    cleanBillingSystemStore();
}

export function setMonthlyOrdersForcedUpdateTime(): void {
    const StoreInterface = MonthlyOrdersStore.getInstance();
    StoreInterface.setForcedUpdateTime();
}
